import {lazy} from 'react'
import {Route, Routes} from 'react-router-dom'

export enum ManagementsRouterEnum {
    /*Rotas para Acessos > Usuários*/
    DatatableUsers = '/gestao/acessos/usuarios',
    ProfileUser = '/gestao/acessos/usuarios/:id',
    /*Rotas para Acessos > Perfis*/
    DatatablePrivilege = '/gestao/acessos/perfis',
    StorePrivilege = '/gestao/acessos/perfis/cadastrar',
    UpdatePrivilege = '/gestao/acessos/perfis/:id/atualizar',
    /*Rotas para Clientes*/
    DatatableClient = '/gestao/clientes',
    ProfileClient = '/gestao/clientes/:id',
    /*Rotas para Avaliações*/
    DatatableRating = '/gestao/avaliacoes',
}

/*Rotas para Acessos > Usuários*/
const DatatableUsers = lazy(() => import('../../pages/management/users/DatatableUsers'))
const ProfileUser = lazy(() => import('../../pages/management/users/ProfileUser'))

/*Rotas para Acessos > Perfis*/
const DatatablePrivileges = lazy(
    () => import('../../pages/management/access/privilege/DatatablePrivilege')
)
const StorePrivilege = lazy(
    () => import('../../pages/management/access/privilege/StorePrivilege')
)
const UpdatePrivilege = lazy(
    () => import('../../pages/management/access/privilege/UpdatePrivilege')
)

/*Rotas para Clientes*/
const DatatableClient = lazy(() => import('../../pages/management/clients/DatatableClient'))
const ProfileClient = lazy(() => import('../../pages/management/clients/ProfileClient'))

/*Rotas para Avaliações*/
const DatatableRating = lazy(
    () => import('../../pages/management/clients/rating/DatatableRating')
)

export default function ManagementsRouter() {
    return (
        <Routes>
            {/* Paths relativos ao prefixo /gestao consumido em PrivateRoutes */}
            {/*Rotas para Usuários*/}
            <Route path='acessos/usuarios/:id' element={<ProfileUser />} />
            <Route path='acessos/usuarios' element={<DatatableUsers />} />

            {/*Rotas para Perfis*/}
            <Route path='acessos/perfis/:id/atualizar' element={<UpdatePrivilege />} />
            <Route path='acessos/perfis/cadastrar' element={<StorePrivilege />} />
            <Route path='acessos/perfis' element={<DatatablePrivileges />} />

            <Route path='clientes/:id' element={<ProfileClient />} />
            <Route path='clientes' element={<DatatableClient />} />

            <Route path='avaliacoes' element={<DatatableRating />} />
        </Routes>
    )
}
